export const bannerNewStyles = {
    root: {
        position: "relative",
        width: "100%",
        marginTop: { sm: "0px", xs: "0" },
    },
    textContainer: {
        display: "flex",
        width: { lg: "46%", sm: "65%", xs: "90%" },
        flexDirection: "column",
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        bottom: { md: "9%", sm: "10%", xs: "6%" },
        gap: { xs: "16px", sm: "30px", lg: "40px" },
    },
    bannerText: {
        textAlign: { xs: "left", md: "center" },
        color: "white",
        fontSize: { md: "56px", sm: "40px", xs: "28px" },
        lineHeight: { md: "70px", sm: "46px", xs: "36px" },
        letterSpacing: { xs: "0", sm: "-2%" },
    },
    sliderContainer: {
        "& .slick-dots": {
            bottom: "5% !important",
        },
        "& .slick-active .slackContainer": {
            background: "white !important",
            height: "2px !important",
            marginBottom: "10px !important",
            position: "relative",
            top: "-1px",

        },
        "& .slick-dots li": {
            width: "fit-content !important",
            height: "20px !important",
            margin: "0 !important",
            position: "relative"
        },
        "& .slackContainer": {
            background: "lightgrey !important",
            height: "1px !important",
            position: "relative",
            zIndex: 1,
        },
        "@media (max-width: 600px)": {
            "& .slick-dots": {
                display: "none",
            },
        },
    },
    image: {
        height: { xs: "450px", sm: "713px" },
        objectFit: { md: "fill", xs: "cover" },
        width: "100%"
    },
    bannerWrap: {
        position: "relative",
    },
    overlayBox: {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "99.5%",
        //backgroundColor: "rgba(0, 0, 0, 0.5)",
        color: "white",
    },
    textWrap: {
        position: "absolute",
        top: { xs: "35%", xs4: "45%", md: "40%", },
        left: { lg: "7%", md: "6.5%", sm: "6%", xs: "5%" },
        gap: { sm: "30px", xs: "10px" },
        width: { md: "75%", sm: "80%", xs: "90%" }
    },
    textHeader: {
        fontFamily: "Lexend",
        fontWeight: "600",
        fontSize: { xs: "26px", sm: "35px", md: "40px", lg: "64px",},
        lineHeight: { xs: "32px", sm: "39px", md: "44px", lg: "74px" },
        mb: { xs: "6.81px", sm: "12px", md: "13.58px" },
        maxWidth: { xs: "75%", sm: "100%" },
    },
    span: {
        fontWeight: "400",
        fontFamily: "Belleza",
    },
    bodywrap: {
        maxWidth: { xs: "100%", sm: "75%" },
    },
    bodyText: {
        fontFamily: "Lexend",
        fontWeight: "300",
        fontSize: { xs: "16px", md: "21px" },
        lineHeight: { xs: "24px", md: "26px" },
        color: "#FFFFFF",
        letterSpacing: { xs: "0", sm: "1px" },
    },
    btn: {
        mt: { xs: "14.78px", sm: "38.78px" },
        fontWeight: { xs: "500", sm: "600" },
        fontSize: { xs: "12px", sm: "16px", md: "20px" },
        lineHeight: { xs: "14px", sm: "16px", md: "20px" },
        backgroundColor: "white",
        color: "black",
        textDecoration: "none",
        boxShadow: "none",
        borderRadius: "0px",
        width: { xs: "171.14px", sm: "280px", md: "302.45px" },
        height: { xs: "39.61px", sm: "50px", md: "70px" },
    },
    slackContainer: {
        width: { md: "10vw", sm: "10vw" },
        background: "lightgrey",
        position: "relative",
        display: { sm: "block", xs: "none" },
        zIndex: "10"
    },
    slideIndex: {
        position: "absolute",
        bottom: "25px",
        left: "3px",
        color: "white",
        fontFamily: "sans-serif",
        fontSize: "12px",
    },
}